<!--  ******************************************************  -->
<!--  ADD or UPDATE CUSTOMER DIALOG                           -->
<!--    - Allows the customerUser to insert or update a customer      -->
<!--  ******************************************************  -->
<mat-toolbar class="dialogToolbar">
  <h2 mat-dialog-title fxFlex>
    {{'CUSTOMER.ADD' | translate}}
  </h2>
  <button mat-icon-button color="accent" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="mat-typography dialogBody">


    <form class="example-form" #putCustomer="ngForm">

      <!--  ************************************  -->
      <!--            CUSTOMER NAME               -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.TITLE' | translate}}</mat-label>
        <input matInput required #customerTitle="ngModel" type="text" name="customerTitle" [(ngModel)]="data.customer.title">
        <mat-error *ngIf="customerTitle.invalid">
          {{'CUSTOMER.TITLE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--            CUSTOMER EMAILS             -->
      <!--  ************************************  -->
      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.EMAILS' | translate}}</mat-label>
        <input matInput #customerEmails="ngModel" pattern="{{gmService.MULTIPLE_EMAIL_PATTERN_VALIDATOR}}" type="text" name="customerEmails" [(ngModel)]="emailList">
        <mat-error *ngIf="customerEmails.dirty && emailList !== '' && customerEmails.invalid">
          {{'CUSTOMER.EMAILS_FIELD' | translate}} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate}}</strong>
        </mat-error>
      </mat-form-field>

      <!--  ************************************  -->
      <!--            PARENT CUSTOMER             -->
      <!--  ************************************  -->

      <mat-form-field class="fullWidthField">
        <mat-label>{{'CUSTOMER.PARENT_CUSTOMER_TITLE' | translate}}</mat-label>

        <input type="text" matInput class="mat-typography" #customerSelect (focus)="customerSelect.select()" (click)="data.customer.parentCustomer = undefined"  [matAutocomplete]="auto" [formControl]="customerSelectionControl" name="parentCustomerId" [(ngModel)]="parentCustomer" >

        <mat-autocomplete #auto="matAutocomplete" requireSelection [displayWith]="displayFn" (optionSelected)="parentId = parentCustomer? parentCustomer.id : ''">
          <mat-option (click)="data.customer.parentCustomer = undefined;filterCustomer_init()"><span class="mat-typography">{{'CUSTOMER.PARENT_CUSTOMER_NO_FATHER' | translate}}</span></mat-option>
          <mat-option [disabled]="customer.id === data.customer.id" *ngFor="let customer of filteredCustomers | async" [value]="customer"><span class="mat-typography">{{customer.title}}</span></mat-option>
        </mat-autocomplete>

      </mat-form-field>


      <button style="height: 40px" type="button" mat-raised-button color="primary" (click)="fileInput.click()">{{'CUSTOMER.PICTURE' | translate}}</button>
      <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
      <span *ngIf="!!selectedFile" style="margin-left: 5px"><i>{{selectedFile.name}}</i></span>
      <button style="margin-left: 5px" *ngIf="!!selectedFile" type="button" mat-mini-fab color="primary"
              (click)="resetImage()"><mat-icon>close</mat-icon></button>

    </form>
</mat-dialog-content>

<mat-divider></mat-divider>

<!--  *****************************************  -->
<!--    CLOSE/SAVE DIALOG ACTION BUTTON          -->
<!--  *****************************************  -->
<mat-dialog-actions align="end" class="dialogFooter">
  <button mat-button [mat-dialog-close]="null">{{'BUTTONS.CLOSE' | translate}}</button>
  <button mat-button class="primaryButton" [disabled]="putCustomer.invalid || checkSelection()" (click)="saveCustomer(data.customer)">{{'BUTTONS.SAVE' | translate}}</button>
</mat-dialog-actions>
